import React, { useEffect, useState } from "react";
import PageSectionContainer from "../common/page-section-container";
import PageSectionHeading from "../common/page-section-heading";
import AuthorNames from "../author-names";
import Img from "gatsby-image"; // @ts-ignore
import ImageCaption from "./image-caption";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../../tailwind.config";
import DOMWindow from "../../util/dom-wrapper/window";
import format from "date-fns/format/index";
import de from "date-fns/locale/de";
import SubscriptionBadge, { SubscriptionBadgeSize } from "../badge/subscription-badge";
import { useIsEditionSpotlightMagazine } from "../../hooks/use-is-edition-spotlight-magazine";
import { replaceQuotationMarksWithGuillemets } from "../../util/format/guillemets";
var ArticleView = function ArticleView(_ref) {
    var title = _ref.title, articleId = _ref.articleId, renderSidebar = _ref.renderSidebar, sectionTitle = _ref.sectionTitle, authors = _ref.authors, image = _ref.image, visibility = _ref.visibility, renderContent = _ref.renderContent, renderContentSidebar = _ref.renderContentSidebar, audioStatus = _ref.audioStatus, firstPublishedAt = _ref.firstPublishedAt;
    var _useState = useState(null), book = _useState[0], setBook = _useState[1];
    var renderAudio = function renderAudio() {
        return audioStatus && audioStatus.status === "AVAILABLE" &&
            /*#__PURE__*/
            // @ts-ignore
            React.createElement("audio", {
                controls: true,
                src: audioStatus.url,
                type: "audio/mpeg",
                className: "w-full mt-2 mb-4"
            });
    };
    var cssFullConfig = resolveConfig(tailwindConfig);
    var lgWidth = parseInt(cssFullConfig.theme.screens.lg);
    var getIconsStatus = function getIconsStatus() {
        return DOMWindow.innerWidth() >= lgWidth;
    };
    var _useState2 = useState(getIconsStatus()), showSidebarIcons = _useState2[0], setSidebarIconsStatus = _useState2[1];
    useEffect(function () {
        var onResize = function onResize() {
            setSidebarIconsStatus(getIconsStatus());
        };
        DOMWindow.addEventListener("resize", onResize);
        return function () {
            return DOMWindow.removeEventListener("resize", onResize);
        };
    }, []);
    useEffect(function () {
        var getRandomItem = function getRandomItem(array) {
            return array[Math.floor(Math.random() * array.length)];
        };
        if (authors.length && authors.find(function (a) {
            return a.books.length;
        })) {
            var authorsWithBooks = authors.filter(function (a) {
                return a.books.length;
            });
            var author = authorsWithBooks.length > 1 ? getRandomItem(authorsWithBooks) : authorsWithBooks[0];
            var _book = author.books.length > 1 ? getRandomItem(author.books) : author.books[0];
            setBook(_book);
        }
    }, [authors]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap pb-8 justify-center"
    }, renderSidebar && renderSidebar(), /*#__PURE__*/ React.createElement("div", {
        className: "w-full lg:w-2/3 lg:pl-2 " + (renderSidebar ? "" : "w-full")
    }, /*#__PURE__*/ React.createElement(PageSectionContainer, null, /*#__PURE__*/ React.createElement(PageSectionHeading, {
        className: "mb-4",
        title: sectionTitle
    }), /*#__PURE__*/ React.createElement("div", {
        className: "px-3 lg:pl-8 lg:pr-12"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-3xl leading-tight mb-4 md:text-4xl article-title"
    }, /*#__PURE__*/ React.createElement(SubscriptionBadge, {
        size: SubscriptionBadgeSize.DETAIL,
        articleId: articleId,
        visibility: visibility,
        isEdition: useIsEditionSpotlightMagazine() === "is-edition"
    }), replaceQuotationMarksWithGuillemets(title)), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(AuthorNames, {
        authors: authors,
        className: "inline-block"
    }), firstPublishedAt && /*#__PURE__*/ React.createElement("span", null, " ", "| ", format(new Date(firstPublishedAt), "dd. MMMM yyyy", {
        locale: de
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "mb-4 mt-6 relative"
    }, image && image.fluid ? /*#__PURE__*/ React.createElement(Img, {
        fluid: image.fluid
    }) : "", image && image.title ? /*#__PURE__*/ React.createElement(ImageCaption, {
        caption: image.title,
        customData: image.customData
    }) : ""), /*#__PURE__*/ React.createElement("div", {
        className: "contents lg:hidden"
    }, renderContentSidebar && renderContentSidebar({
        showAuthorInfo: false,
        book: book
    })), renderAudio(), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "content-wrapper lg:flex-1 lg:pr-5"
    }, renderContent()), renderContentSidebar && renderContentSidebar({
        showIcons: showSidebarIcons,
        book: book
    })))))));
};
export default ArticleView;
